<template>
  <div>
    <!-- 그룹 설정 -->
    <div v-if="settingMode === 'group'">
      <div class="item">
        <div class="label toCapitalize f_medium">{{locale.roomcontrol_group_viewtype}}</div>
        <div class="optionGroup mt10">
          <div class="label toLowercase colorGrey">{{locale.viewtype}}</div>
          <div class="box viewType">
            <span class="type" data-type="list">
              <input type="radio" name="view_type" id="view_type_list" value="list" v-model="groupInfo.viewtype">
              <label for="view_type_list"></label>
            </span>
            <span class="type" data-type="grid2">
              <input type="radio" name="view_type" id="view_type_grid2" value="grid2" v-model="groupInfo.viewtype">
              <label for="view_type_grid2"></label>
            </span>
            <span class="type" data-type="grid">
              <input type="radio" name="view_type" id="view_type_grid" value="grid" v-model="groupInfo.viewtype">
              <label for="view_type_grid"></label>
            </span>
          </div>
        </div>
        <div v-if="groupInfo.viewtype.includes('grid')" class="optionGroup mt10">
          <div class="label toLowercase colorGrey">{{locale.align}}</div>
          <div class="box viewType">
            <span class="type" data-align="flex-start">
              <input type="radio" name="grid_align" id="grid_align_left" value="flex-start" v-model="groupInfo.viewtypeAlign">
              <label for="grid_align_left"></label>
            </span>
            <span class="type" data-align="center">
              <input type="radio" name="grid_align" id="grid_align_center" value="center" v-model="groupInfo.viewtypeAlign">
              <label for="grid_align_center"></label>
            </span>
            <span class="type" data-align="flex-end">
              <input type="radio" name="grid_align" id="grid_align_right" value="flex-end" v-model="groupInfo.viewtypeAlign">
              <label for="grid_align_right"></label>
            </span>
          </div>
        </div>
      </div>
    </div>
    <!-- //그룹 설정 -->
    <!-- 모듈 설정 -->
    <div v-if="settingMode === 'module'">
      <div class="item">
        <div class="label toCapitalize f_medium">{{locale.roomcontrol_control_type}}</div>
        <div class="optionGroup mt10">
          <div class="label toLowercase colorGrey">{{locale.type}}</div>
          <div class="box">
            <select class="input"
              v-model="typeInfo.detail.type"
              @change="update(typeInfo.detail.type)">
              <option
                v-for="item in type"
                :key="item.name"
                :value="item.name">
                {{item.name}}
              </option>
            </select>
          </div>
        </div>
        <div class="optionGroup mt10">
          <div class="label toLowercase colorGrey">{{locale.icon}}</div>
          <div class="box">
            <div class="icons">
              <div class="icon"
                v-for="index in selectType.icon"
                :key="`control_icon_${index}`">
                <input
                  type="radio"
                  name="control_icon"
                  :id="`${selectType.name}_${index}`"
                  :value="`${selectType.name}_${index}`"
                  v-model="typeInfo.detail.icon">
                <label :for="`${selectType.name}_${index}`">
                  <img :src="icon(selectType.name, index)" alt="">
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 멀티제어 설정 -->
      <div v-if="typeInfo.extra && typeInfo.index === 'multi'" class="item">
        <div class="label toCapitalize f_medium">{{locale.setting_roomcontrol_multi}}</div>
        <ul class="multiList multiOnoff">
          <li v-for="item in multiList"
            :key="item.index">
            <span class="checkbox multiActive">
              <input
                type="checkbox"
                :name="`${item.type}_multi`"
                :id="`${item.type}_multi_${item.index}`"
                :value="item.index"
                v-model="typeInfo.multi">
              <label
                :for="`${item.type}_multi_${item.index}`">
                {{item.index}}: {{item.location}}
              </label>
            </span>
            <div v-if="typeInfo.type === 'light' && typeInfo.multi.includes(item.index)" class="multiOnoff">
              <span class="checkbox onoff" :data-on="typeInfo.multiOnoff.includes(item.index)">
                <input
                  type="checkbox"
                  :name="`${item.type}_multi_onoff`"
                  :id="`${item.type}_multi_onoff_${item.index}`"
                  :value="item.index"
                  v-model="typeInfo.multiOnoff">
                <label
                  :for="`${item.type}_multi_onoff_${item.index}`"></label>
              </span>
            </div>
          </li>
        </ul>
      </div>
      <!-- //멀티제어 설정 -->
      <!-- 타입별 설정:: fcu -->
      <div v-if="typeInfo.detail.type === 'fcu'" class="item">
        <div class="label toCapitalize f_medium">{{locale.fcu_type}}</div>
        <ul class="multiList">
          <li
            v-for="item in selectType.control"
            :key="item">
            <span class="checkbox radio"
              :class="{disabled: fcuDisabledOption(item)}">
              <input
                type="radio"
                name="fcu_control"
                :id="`fcu_control_${item}`"
                :value="item"
                :disabled="fcuDisabledOption(item)"
                v-model="typeInfo.detail.control">
              <label
                :for="`fcu_control_${item}`">
                {{item}}
              </label>
            </span>
          </li>
        </ul>
      </div>
      <!-- //타입별 설정:: fcu -->
      <!-- 
        타입별 설정:: fcu - temp range
        t계정만 설정 가능하며 사이트 kppiy에서만 사용할듯함
        AS-IS: 뷰어에서는 실내온도임을 감안하여 고정으로 18~28까지만 콤보박스로 제어가능
        rcu 업체에서(kppiy 세팅할 때) 온도를 5 ~ 50까지 설정 가능하도록 열었으나
        모든 범위가 뷰어에 나타나지 않는다 하여
        제어가능 온도 범위를 ***이와 같은 특별한 상황***에서 수정할 수 있도록 하기 위해 추가함
       -->
      <div v-if="typeInfo.detail.type === 'fcu' && isSuperadmin" class="item">
        <div class="label toCapitalize f_medium">FCU temp range</div>
        <div class="optionGroup mt10">
          <div class="label toLowercase colorGrey">min</div>
          <div class="box"><input type="input" class="input" v-model="typeInfo.detail.tempMin" placeholder="10" /></div>
        </div>
        <div class="optionGroup mt10">
          <div class="label toLowercase colorGrey">max</div>
          <div class="box"><input type="input" class="input" v-model="typeInfo.detail.tempMax" placeholder="35" /></div>
        </div>
      </div>
      <!-- //타입별 설정:: fcu - temp range -->
      <!-- 타입별 설정:: 커튼 -->
      <div v-if="typeInfo.detail.type === 'curtain'" class="item">
        <div class="label toCapitalize f_medium">{{locale.roomcontrol_curtain_control}}</div>
        <ul class="multiList">
          <li>
            <div class="checkbox">
              <input type="checkbox" id="curtain_open" checked disabled>
              <label for="curtain_open">OPEN</label>
            </div>
          </li>
          <li>
            <div class="checkbox">
              <input type="checkbox" id="curtain_close" checked disabled>
              <label for="curtain_close">CLOSE</label>
            </div>
          </li>
          <li>
            <div class="checkbox">
              <input type="checkbox" id="curtain_stop" v-model="typeInfo.detail.stop">
              <label for="curtain_stop">STOP</label>
            </div>
          </li>
        </ul>
      </div>
      <!-- //타입별 설정:: 커튼 -->
    </div>
    <!-- //모듈 설정 -->
  </div>
</template>

<script>
export default {
  props: [
    'locale',
    'typeInfo',
    'groupInfo',
    'typeParent'
  ],
  computed: {
    isSuperadmin () {
      return this.$store.getters['authentication/getAuthority']
    },
    settingMode () {
      let mode
      if (this.groupInfo) {
        mode = 'group'
      }
      if (this.typeInfo) {
        mode = 'module'
      }
      return mode
    },
    selectType () {
      const selected = this.typeInfo.detail.type
      const init = this.type[0]
      const type = this.type.find(x => x.name === selected)
      return type || init
    },
    multiList () {
      return this.typeParent.children.filter(x => !x.extra)
    }
  },
  data () {
    return {
      type: [
        { name: 'light', icon: 5 },
        { name: 'fcu', icon: 5, control: ['toggle', 'speed', 'temp'] },
        { name: 'dm', icon: 2 },
        { name: 'curtain', icon: 4, stop: false },
        { name: 'door', icon: 2 }
      ]
    }
  },
  methods: {
    icon (type, index) {
      return require(`@/assets/img/roomcontroller/ico_${type}_${index}.png`)
    },
    update (type) {
      const data = {
        type: type,
        icon: `${type}_1`,
        ...type === 'fcu' && { control: 'toggle' }
      }
      this.$emit('updateDetail', data)
    },
    fcuDisabledOption (option) {
      const isExtra = this.typeInfo.extra && (this.typeInfo.index === 'all' || this.typeInfo.index === 'multi')
      return option !== 'toggle' && isExtra
    },
    onClose () {
      this.$emit('close')
    }
  }
}
</script>

<style lang="scss" scoped>
.icons {
  display: flex;
  flex-wrap: wrap;
  .icon {
    width: calc(33.33% - 5px);
    margin-bottom: 5px;
    margin-right: 5px;
    background-color: $color-white;
    label {
      display: block;
      padding: 15px;
      border: 1px solid $color-lgrey2;
      cursor: pointer;
    }
    img {
      opacity: 0.3;
    }
    :checked + label {
      border-color: $color-primary;
      img {
        opacity: 0.75;
      }
    }
  }
}
.multiList li {
  margin-bottom: 5px;
}
.multiOnoff {
  li {
    display: flex;
    margin-bottom: 10px;
    .multiActive {
      flex: 1;
    }
    .multiOnoff {
      display: block;
      margin-left: auto;
      .checkbox {
        margin-right: 0;
        margin-left: 8px;
        vertical-align: top;
      }
      label {
        height: 12px;
        padding-left: 36px;
      }
      label:before {
        background-color: $color-lgrey2;
      }
      label:after {
        background-color: $color-lgrey;
      }
      :checked + label:after {
        background-color: $color-dark;
      }
    }
  }
}
.viewType {
  .type {
    display: inline-block;
    vertical-align: middle;
    label {
      display: block;
      padding: 4px;
      border: 1px solid $color-lgrey;
      cursor: pointer;
      &:before {
        content: "";
        display: block;
        width: 32px;
        height: 32px;
        background-size: contain;
        background-repeat: no-repeat;
        background-position: 50% 50%;
        opacity: 0.15;
      }
    }
    & + .type {
      margin-left: 5px;
    }
    :checked+label {
      border-color: $color-dark;
      &:before {
        opacity: 0.75;
      }
    }
  }
  [data-type="grid"] label:before {
    background-image: url('~@/assets/img/ico_control_grid.png');
  }
  [data-type="grid2"] label:before {
    background-image: url('~@/assets/img/ico_control_grid2.png');
  }
  [data-type="list"] label:before {
    background-image: url('~@/assets/img/ico_control_list.png');
  }
  [data-align="flex-start"] label:before {
    background-image: url('~@/assets/img/ico_grid_left.png');
  }
  [data-align="center"] label:before {
    background-image: url('~@/assets/img/ico_grid_center.png');
  }
  [data-align="flex-end"] label:before {
    background-image: url('~@/assets/img/ico_grid_right.png');
  }
}
</style>
